// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Ek","icon":"i_El"};